import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__ListGroupItem_js_c0bddf8e__ from "./ListGroupItem.js";
import * as __WEBPACK_EXTERNAL_MODULE__ListGroup_module_js_85fa34a4__ from "./ListGroup.module.js";
function ListGroup(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ul", {
        className: __WEBPACK_EXTERNAL_MODULE__ListGroup_module_js_85fa34a4__["default"].ListGroup,
        children: children
    });
}
ListGroup.Item = __WEBPACK_EXTERNAL_MODULE__ListGroupItem_js_c0bddf8e__["default"];
export { ListGroup as default };

//# sourceMappingURL=ListGroup.js.map